import PropTypes from 'prop-types';
import { Icon, SwitchButton } from '@bwoty-web/ui-kit';
import { UI_SCROLL_HORIZONTAL, UI_SCROLL_VERTICAL } from '@bwoty-web/ui-kit/icons';

const CarouselSwitchButton = ({ label, showCardsInCarousel, toggleCardView }) => (
  <SwitchButton
    checked={showCardsInCarousel}
    label={label}
    leftUnCheckedElement={
      <Icon
        path={UI_SCROLL_VERTICAL}
        size="xs"
      />
    }
    onChange={toggleCardView}
    rightCheckedElement={
      <Icon
        path={UI_SCROLL_HORIZONTAL}
        size="xs"
      />
    }
  />
);

CarouselSwitchButton.propTypes = {
  label: PropTypes.string.isRequired,
  showCardsInCarousel: PropTypes.bool.isRequired,
  toggleCardView: PropTypes.func.isRequired,
};

export default CarouselSwitchButton;
